import { call, fork, put, select, take } from "redux-saga/effects";

// Actions
import * as actionsCreator from "./reducer";

// Helper
import { RootState } from "store";
import { convertOptions } from "lib/prices";

// Store
export const settings = (store: RootState) => store.settings;

function* _select<T>(fn: (state: RootState) => T) {
  const res: T = yield select(fn);
  return res;
}

// Type
type TMap = {
  [index: string]: string | number | boolean
}
type TOptions = {
  label?: string;
  value?: string;
};

// Start Sagas
export function* chemicalProbesSagaStart(api: any, action: any) {
  yield fork(getChemicalProbesWatcher, api, action);
}

/**
 *  Get all chemical probes watcher sagas
 *
 * @param {function} api - api object
 * @param {object} action - action from dispatch
 * @returns
 */
export function* getChemicalProbesWatcher(api: any, action: any): Generator<any, void, any> {
  while (true) {
    try {
      yield take(actionsCreator.getChemicalProbes.type);

      const res = yield call(api.request, "getChemicalProbes");

      if (!res.ok) {
        yield put(actionsCreator.getChemicalProbesError());
      } else {
        const data = res.data || [];
        const state = yield* _select(settings);

        const formData = data?.length ? data.map(({ compound, ...rest }: any) => {
          const options: TMap[] = convertOptions(compound.prices[0].prices);
          const countPrice = options.filter(o => !o.value).length;

          return {
            ...compound,
            ...rest,
            quantity: 1,
            selected: false,
            currentTypePrice: "EBC",
            px: rest.px ? rest.px : '',
            currentPrice: state.currentPrice,
            isPOA: options.length === countPrice,
            action: rest.action ? rest.action : '',
          }
        }) : [];

        const getFilteredPX: any = [ ...new Set(formData.map((item: any) => item.px).filter(Boolean)) ];
        const getFilteredAction: any = [ ...new Set(formData.map((item: any) => item.action).filter(Boolean)) ];

        const optionsAction: TOptions[] = getFilteredAction?.length ? getFilteredAction?.map((item: string) => ({
          label: item,
          value: item
        })) : [];
        const optionsPX: TOptions[] = getFilteredPX?.length ? getFilteredPX?.map((item: string) => ({
          label: item,
          value: item
        })) : [];

        optionsAction.unshift({
          label: 'All',
          value: ''
        });

        yield put(actionsCreator.getChemicalProbesSuccess({
          px: optionsPX,
          data: formData,
          action: optionsAction,
        }));
      }
    } catch (e) {
      console.log("CATCH ERROR: getChemicalProbesWatcher: ", e);
    }
  }
}
